import React__default, { Children } from 'react';
import { Icon } from '../../display/Icon/Icon.es.js';

const root = "_root_bwcu1_1";
const list = "_list_bwcu1_14";
const item = "_item_bwcu1_25";
const styles = {
	root: root,
	list: list,
	item: item
};

const Breadcrumbs = ({ children, size = "large" }) => {
  const iconSize = {
    small: 20,
    large: 24
  }[size];
  const items = Children.toArray(children).filter(Boolean).map((link, i, links) => {
    const icon = i !== links.length - 1 && React__default.createElement(
      "span",
      { "aria-hidden": "true", "data-zds": true },
      React__default.createElement(Icon, { isBlock: true, color: "GrayWarm4", name: "arrowSmallRight", size: iconSize })
    );
    return React__default.createElement(
      "li",
      { className: styles.item, key: i, "data-zds": true },
      link,
      icon
    );
  });
  return React__default.createElement(
    "div",
    { className: styles.root, "data-size": size, "data-zds": true },
    React__default.createElement("ol", { className: styles.list, "data-zds": true }, items)
  );
};

export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.es.js.map
